import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    claims: [],
    active: [],
    order_column: 'status',
    order_type: 'asc'
  },

  mutations: {
    setClaims(state, payload) {
      state.claims = payload
    },
    setActive(state, payload) {
      state.active = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    readClaims({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/youtube/claims/removal')
        .then(r => {
          commit('setClaims', r.data.data.data)
          commit('setActive', r.data.data.active)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    releaseClaim({ commit, dispatch }, data) {
      commit('setLoading', true)
      axios.admin
        .put(
          'cms/youtube/claims/removal/release/' + data.row + '/' + data.claimId
        )
        .then(() => {
          dispatch('readClaims')
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    releaseAllClaims({ commit, dispatch }) {
      commit('setLoading', true)
      axios.admin
        .put('cms/youtube/claims/removal/releaseAll')
        .then(() => {
          commit('setLoading', false)
          dispatch('readClaims')
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
